const providers = new Map();

export function registerOcrProvider(key, provider) {
  if (key && provider) {
    providers.set(key, provider);
  }
}

export function getOcrProvider() {
  const key = import.meta.env?.VITE_OCR_PROVIDER;
  if (!key) {
    return null;
  }
  return providers.get(key) || null;
}

